// extracted by mini-css-extract-plugin
module.exports = {"root":"desktop-map_root__Nmgxg","closeButton":"desktop-map_closeButton__1MvCV","mapContainer":"desktop-map_mapContainer__2t9MM"};